import { render, staticRenderFns } from "./shang-pin-wai-gou.vue?vue&type=template&id=103ffc9f&scoped=true"
import script from "./shang-pin-wai-gou.vue?vue&type=script&lang=js"
export * from "./shang-pin-wai-gou.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-wai-gou.vue?vue&type=style&index=0&id=103ffc9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103ffc9f",
  null
  
)

export default component.exports